export const POSITIVE_LIST_MEASURE_QUERY_KEY = "gdpr-software-positive-list-measure";

const EVIDENCE_SOURCE_LABELS = {
    provider_documentation: "Provider documentation",
    internal_documentation: "Internal documentation",
    security_documentation: "Security documentation",
    asset_handbook: "Asset handbook",
    playbook: "Playbook",
    uploaded_evidence: "Uploaded evidence",
    external_reference: "External reference",
};

export const EVIDENCE_SOURCE_OPTIONS = Object.entries(EVIDENCE_SOURCE_LABELS).map(
    ([value, labelKey]) => ({ value, labelKey })
);

export const getEvidenceSourceLabel = (sourceType) => {
    return EVIDENCE_SOURCE_LABELS[sourceType] || sourceType || "";
};

export const buildAddEvidencePayload = (values) => {
    const payload = {
        source_type: values.sourceType,
        description: typeof values.description === "string"
            ? values.description.trim()
            : "",
    };
    const referenceUrl = typeof values.referenceUrl === "string"
        ? values.referenceUrl.trim()
        : "";

    if (referenceUrl) {
        payload.reference_url = referenceUrl;
    }

    if (values.softwareAttachmentId) {
        payload.software_attachment_id = Number(values.softwareAttachmentId);
    }

    return payload;
};
